export default "__VITE_ASSET__a8cc4ac0__"